import React from "react";
import { formatDuration } from "../../services/uiHelpers.js";

/**
 * DurationDisplay Component
 * Displays duration in read-only format
 */
const DurationDisplay = ({ duration, formatTime, onClick, className = "timer-sec-input" }) => {
  return (
    <div className={className} onClick={onClick}>
      <input
        style={{ cursor: onClick ? "pointer" : "default" }}
        className="before-edit-input"
        name="time"
        value={formatDuration(duration, formatTime)}
        placeholder="00:00:00"
        type="text"
        autoComplete="off"
        readOnly
      />
    </div>
  );
};

export default DurationDisplay;
